import { render, staticRenderFns } from "./ModalController.vue?vue&type=template&id=a8bcbb9c"
import script from "./ModalController.vue?vue&type=script&lang=js"
export * from "./ModalController.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports